import { Button } from '@finn/design-system/atoms/button';
import { TrackingEventName } from '@finn/ua-tracking';
import { cn, parseToHtml, trackEvent } from '@finn/ui-utils';

type ConversionElementProps = {
  title?: string;
  href?: string;
  image?: { src?: string; alt: string; url?: string };
  color_hex?: string;
  sticky?: boolean;
  index?: number;
  tracking?: string;
};

// figma https://www.figma.com/design/y5BwvgDSgQmnLGFJWJqISe/Guide-2025?node-id=6507-32509&p=f&m=dev
// on desktop usually it is a sticky element on the right side
// on mobile it is a full width element as regular module
// we use sticky property to adjust styles a bit depending on the screen size

export const ConversionElement = ({
  title,
  href,
  image,
  color_hex,
  sticky,
  tracking,
  index,
}: ConversionElementProps) => {
  const trackingDataNewFormat = {
    name: title,
    link: href,
    location: tracking ?? title,
    type: 'sticky_conversion_element',
  };

  return (
    <div
      className={cn(
        sticky
          ? ''
          : 'container w-full flex-col items-end md:w-[calc(100%-1rem)] md:max-w-[726px]',
        index > 0 ? 'mt-8' : ''
      )}
    >
      <Button
        href={href}
        contentClassName="flex-col items-start rounded overflow-hidden"
        className={cn(
          'relative h-auto p-0 before:hidden after:hidden',
          sticky ? 'w-[232px] max-w-[232px]' : 'w-full'
        )}
        variant="ghost"
        onClick={() =>
          trackEvent(TrackingEventName.CTA_CLICKED, trackingDataNewFormat || {})
        }
      >
        <img
          className="w-full rounded-t"
          src={image?.src || image?.url}
          alt={image.alt}
        />
        <div
          style={{ background: color_hex }}
          className="w-full whitespace-normal bg-black p-4 text-left text-white body-16-semibold"
        >
          {parseToHtml(title)}
        </div>
      </Button>
    </div>
  );
};
